import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import CustomButton from "components/CustomButton";

import {black500} from "assets/jss/main";

import {sessionStore} from "utils/sessionStore";
import {Authorizations, hasAuthorization} from "utils/authorizations";

ReclaimButton.propTypes = {
    onClick: PropTypes.func,
    loading: PropTypes.bool,
};

function ReclaimButton({onClick, loading = false}) {
    const authorizations = sessionStore.get('authorizations');

    if (hasAuthorization(authorizations, Authorizations.PICKING_RETAILER)) {
        return null;
    }

    return (
        <CustomButton
            color="default"
            variant="outlined"
            loading={loading}
            onClick={onClick}
        >
            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" stroke={black500} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <FormattedMessage id="oms.order.list.runner.reclaim" />
            </div>
        </CustomButton>
    );
}

export default ReclaimButton;
